import { normalizarTexto } from '../../../shared/utils/slug.util';
import { ResultadoBusca } from '../models/busca.model';

/**
 * A faixa de relevância de um título, a mesma régua da API: 0 igual ao termo, 1 começa com,
 * 2 contém, 3 o restante. Sem caixa nem acento.
 */
export function faixaRelevancia(titulo: string, termo: string): 0 | 1 | 2 | 3 {
  const alvo = normalizarTexto(termo);

  if (!alvo) return 3;

  const texto = normalizarTexto(titulo);

  if (texto === alvo) return 0;
  if (texto.startsWith(alvo)) return 1;

  return texto.includes(alvo) ? 2 : 3;
}

/**
 * Os registros da API e as páginas do portal numa lista só, pela faixa de relevância.
 *
 * O `sort` é estável: dentro da mesma faixa a ordem de entrada se mantém, então quem chama
 * passa primeiro os registros (já na ordem da API) e depois as páginas, e é assim que eles
 * saem. "Ouvidoria" põe a página Ouvidoria no topo; "IPTU" não traz página nenhuma.
 */
export function ordenarResultados(termo: string, itens: readonly ResultadoBusca[]): ResultadoBusca[] {
  return [...itens].sort((a, b) => faixaRelevancia(a.titulo, termo) - faixaRelevancia(b.titulo, termo));
}
